import * as actions from '@app/actions/index';
import { IDashboardComponentProps } from '@app/models';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import DashboardComponent from './dashboard.component';

function mapStateToProps(authState: any): IDashboardComponentProps {
	return {
		intl: null,
		openSnackBar: null,
	};
}

function mapDispatchToProps(dispatch: Dispatch<actions.AuthActions>): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardComponent);



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard/dashboard.ts